













































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";
import DropdownList from "./dropdownList/dropdownList.vue";
import ArrowDown from "./resources/arrowDown.vue";
import { DebugHelper } from "@/helper/debugHelper";

@Component({
    components: {
        DropdownList,
        ArrowDown,
    }
})

export default class SelectExcelSheetModal extends Vue 
{
    private isVisible = false;
    private callback : ((button : string, index : number)  => void) | null = null;

    private sheetItems : Array<{id : number, isSelected : boolean, label : string}> = [];
    private sheetIndex = 0;

    private isSheetDropdownVisible = false;

    private get sheetName()
    {
        var name = "";
        if(0 <= this.sheetIndex && this.sheetIndex < this.sheetItems.length)
        {
            name = this.sheetItems[this.sheetIndex].label;
        }
        return name;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    public open(sheetNames : Array<string>, callback : (button : string, index : number) => void)
    {
        DebugHelper.trace("open");
        this.isVisible = true;
        this.callback = callback;

        this.sheetItems = [];
        this.sheetIndex = 0;
        for(var i = 0; i < sheetNames.length; ++i)
        {
            this.sheetItems.push({
                id : i,
                isSelected : i == this.sheetIndex,
                label : sheetNames[i]
            });
        }

        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    onClick(button : string)
    {        
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
        this.isVisible = false;

        if(this.callback) this.callback(button, this.sheetIndex);
    }

    onSelectSheet(id : number, tag : string)
    {
        this.sheetIndex = id;
        // 選択状態更新
        for(var i = 0; i < this.sheetItems.length; ++i) this.sheetItems[i].isSelected = i == id;
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorCode() { return this.userConfigColors.buttonColorCode; }

    private get buttonColorStyle(){
        return {
            "background-color" : this.buttonColorCode
        }
    }
}
